// handle the routing in the user dashboard
import React from 'react'

function UserLayout() {
  return (
    <div>UserLayout</div>
  )
}

export default UserLayout